import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_211: DocMigration = {
  maxSchemaVersion: "0.0.211",
  description:
    "Vertical datums and horizontal datums swapped in openings, facades, foundation catalogs, and exterior trim settings",
  apply(json: any) {
    for (const openingId in json.openings) {
      const opening = json.openings[openingId];

      if (opening.type !== "WINDOW" || opening.type !== "WINDOW_V2") {
        const verticalDatum = opening.verticalDatum;
        opening.verticalDatum = opening.horizontalDatum;
        opening.horizontalDatum = verticalDatum;
        continue;
      }

      // DOOR and DOOR_V2
      opening.horizontalDatum = opening.verticalDatum;
      delete opening.verticalDatum;
    }

    for (const facadeId in json.facades) {
      const facade = json.facades[facadeId];
      for (const datumId in facade.datumTable) {
        //if datumType is "HORIZONTAL" then swap vertical and horizontal datums
        const datum = facade.datumTable[datumId];
        if (datum.type === "HORIZONTAL") {
          datum.type = "VERTICAL";
          continue;
        }
        if (datum.type === "VERTICAL") {
          datum.type = "HORIZONTAL";
        }
      }
    }

    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      if (setting.type === "FOUNDATION_CATALOG_SETTINGS") {
        for (const foundationDatumId in setting.foundationDatums) {
          const foundationDatum = setting.foundationDatums[foundationDatumId];
          if (foundationDatum.datumType === "HORIZONTAL") {
            foundationDatum.datumType = "VERTICAL";
          }
        }
        continue;
      }

      if (setting.type === "EXTERIOR_TRIM_SETTINGS") {
        setting.outsideCornerBoardHorizontalDatum = setting.outsideCornerBoardVerticalDatum;
        delete setting.outsideCornerBoardHorizontalDatum;

        setting.insideCornerBoardHorizontalDatum = setting.insideCornerBoardVerticalDatum;
        delete setting.insideCornerBoardVerticalDatum;

        setting.dormerCornerBoardHorizontalDatum = setting.dormerCornerBoardVerticalDatum;
        delete setting.dormerCornerBoardVerticalDatum;
      }
    }
    return json;
  },
};

export default migration_0_0_211;
